<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar @showMsg="showMsg" />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel v-if="showSettings">
        <settings />
      </right-panel>
    </div>
    <SystemMsg ref="systemMsgRef" />
    <ForceResetPasswd v-if="forceResetVisible" :param="forceResetParam" />
  </div>
</template>

<script>
import SystemMsg from '@/components/SystemMsg'
import RightPanel from '@/components/RightPanel'
import ForceResetPasswd from './components/Settings/ForceResetPasswd'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState, mapGetters } from 'vuex'
import { dictDataInterface } from '@/api/dictionary'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView,
    SystemMsg,
    ForceResetPasswd
  },
  mixins: [ResizeMixin],
  data() {
    return {
      forceResetVisible: false,
      forceResetParam: {
        id: ''
      }
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    ...mapGetters(['user']),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  watch: {
    'user.userInfo.userId': {
      handler(val) {
        if (val) {
          this.checkForceReset()
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.$route.path == '/') {
      let url = 'OrderManagement/ParkingRecordOrder'
      let flag = true
      const menuList = this.$store.getters.user.menuList || []
      menuList.forEach((item, index) => {
        if (flag) {
          if (item.type == 2 && item.urlAddress) {
            url = item.urlAddress
            flag = false
          } else if (item.hasChildren) {
            url = item.enCode
            item.children.forEach((itemTwo) => {
              if (flag) {
                if (itemTwo.type == 2 && itemTwo.urlAddress) {
                  flag = false
                  url = url + '/' + itemTwo.enCode
                } else if (itemTwo.hasChildren) {
                  itemTwo.children.forEach((itemThree) => {
                    if (flag) {
                      if (itemThree.type == 2 && itemThree.urlAddress) {
                        flag = false
                        url = url + '/' + itemTwo.enCode
                      }
                    }
                  })
                }
              }
            })
          }
        }
      })
      this.$router.push({ path: '/' + url })
    }
    //this.getExportIp();
    localStorage.removeItem('exportIp');
  },
  methods: {
    showMsg(data){
      this.$refs.systemMsgRef.init(data);
    },
    // getExportIp(){
    //   dictDataInterface('1d6f8b3f42534114b67d523c9b459f44').then(res=>{
    //       if(res.code == 200){
    //         localStorage.setItem('exportIp', res.data.IP);
    //       }
    //   })
    // },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    checkForceReset() {
      const userInfo = this.$store.getters.user.userInfo
      if (userInfo && userInfo.userId && !userInfo.changePasswordDate && !userInfo.prevLoginTime) {
        this.forceResetParam.id = userInfo.userId
        this.forceResetVisible = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/mixin.scss";
  @import "~@/assets/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    background: #031D8B;
    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    width: calc(100vw - (#{$sideBarWidth} + 30px));
    right: 15px;
    z-index: 9;
    transition: width 0.28s;
    padding: 0;
    background-color: #031d8b;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 84px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
